import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import RootLayout from "../layout";
import httpService from "../../services/http.service";
import { getBillingApiRoute } from "../../utils/api.utils";
import SpitialProfileSubscriptions from "../../components/profile/subscriptions";
import { hasAuthenticatedSession } from "../../services/authStorage";

const checkAuth = () => hasAuthenticatedSession();

const ProfileSubscriptionsPage = () => {
  const auth = checkAuth();
  const navigate = useNavigate();

  if (!auth) {
    navigate("/login");
  }

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getProfileInfo() {
    try {
      const response = await httpService.get(getBillingApiRoute("payment"), {
        params: {
          pageIndex: 10,
          pageNumber: 1,
          status: 1,
        },
      });
      const { data } = response.data;

      return data?.results;
    } catch (err) {
      console.log("Payment Status get error", err);
      return err;
    }
  }

  useEffect(() => {
    getProfileInfo().then((data) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  return (
    <RootLayout>
      <SpitialProfileSubscriptions data={data} loading={loading} />
    </RootLayout>
  );
};
export default ProfileSubscriptionsPage;
